import { ForwardedRef, forwardRef, useCallback } from 'react'
import { Controller, FieldValues, get } from 'react-hook-form'
import { TextInput } from 'react-native'

import { Field } from '../../molecules'
import type { ControlledInputProps, RenderInputProps } from './types'

export function InputInner<TFieldValues extends FieldValues>(
  { control, name, errors, rules, children, onBlur, onChangeText, ...props }: ControlledInputProps<TFieldValues>,
  ref?: ForwardedRef<TextInput>
) {
  const errorMessage = get(errors, name)?.message

  const renderInput = useCallback(
    ({ field: { onChange, onBlur: formOnBlur, name, value, ...fieldProps } }: RenderInputProps<TFieldValues>) => {
      const handleChangeText = (text: string) => {
        onChange(text)
        onChangeText?.(text)
      }

      return (
        <Field.Input
          {...props}
          {...fieldProps}
          {...{ name, ref, errorMessage }}
          onBlur={(event) => {
            formOnBlur(event)
            onBlur?.(event)
          }}
          onChangeText={handleChangeText}
          value={value as string}
        />
      )
    },
    [ref, errorMessage, props, onBlur, onChangeText]
  )

  return <Controller name={name} control={control} rules={rules} render={renderInput} />
}

export const Input = forwardRef(InputInner)
